import React, { useContext } from "react";
import { InlineStack, LegacyCard as Card, Badge, Link, Thumbnail, Text } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { statusHelper, baseHelper, imageHelper } from "lib/helpers";
import { useNavigate } from "react-router-dom";

const FulfilledLineItems = (props) => {
  const { lineData, data } = props;
  const { userData, cms } = useContext(PrivateContext);
  const navigate = useNavigate();
  const currentUserData = baseHelper.getResponseData(userData, constant.gql.GET_CURRENT_USER);

  const amount = [];
  const vendorsSum = [];
  let countItems = 0;

  lineData.forEach(({ vendor, price, fulfillmentStatus, quantity = 1 }) => {
    if (fulfillmentStatus === constant.FULFILLED) {
      vendorsSum.push(vendor);
      amount.push(parseFloat(price) * parseInt(quantity, 10));
      countItems += 1;
    }
    return [vendorsSum, amount];
  });
  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;
  // const lineDataItems = lineData.length;

  const stringToNumber = amount.map((item) => parseFloat(item));
  const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);

  const isVendor = baseHelper.isVendor(currentUserData);
  const lineItems = lineData.map((lineItem, idx) => {
    if (!lineItem || lineItem.fulfillmentStatus === constant.UNFULFILLED) {
      return null;
    }
    const lineImage =
      imageHelper.resize({ url: lineItem.image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;
    const lineItemKey = `lineItem${idx}`;
    const { isProductDeleted, isVendorDeleted } = lineItem;

    const moneyFormat = lineItem.moneyFormat || constant.symbol.DOLLAR;
    const lineTotalPrice = lineItem.price * lineItem.quantity;
    const status = statusHelper.getBadgeStatus(lineItem.status);
    const badgeType = baseHelper.getBadgeType(lineItem.status);
    const lineItemName = <div className="productName">{lineItem.name}</div>;
    return (
      <div key={lineItemKey} className="fulfilled-Secn">
        <Card>
          <Card.Section subdued>
            <InlineStack wrap={false}>
              <Thumbnail size="large" source={lineImage} alt={lineItem.name} />
              <div className="ellipsis">
                {(isProductDeleted && (lineItemName || "")) || (
                  <Link onClick={() => navigate(`/products/edit/${lineItem.productId}`)}>{lineItem.name || ""}</Link>
                )}

                <Text variant="bodySm" as="p">
                  <Text color="subdued" as="span">
                    {!(isVendor || isVendorDeleted) && [
                      `${cms("label.vendor")}: `,
                      <Link onClick={() => navigate(constant.PROVIDER_VIEW + lineItem.vendorId)}>
                        {lineItem.vendor}
                      </Link>,
                    ]}
                  </Text>
                  <br />
                  <Text color="subdued" as="span">
                    {cms("label.skuList")}
                    <div className="wrap_sku">{lineItem.sku}</div>
                  </Text>
                </Text>

                <InlineStack>
                  <Badge status={badgeType} className="text-capitalize">
                    {status}
                  </Badge>
                </InlineStack>
              </div>
              <Text as="h5">
                {`${cms("label.qty")}:`}
                {lineItem.quantity}
              </Text>
              <Text as="h5">
                {moneyFormat}
                {(lineTotalPrice && lineTotalPrice.toFixed(2)) || constant.value.ZERO}
              </Text>
            </InlineStack>
          </Card.Section>
        </Card>
      </div>
    );
  });
  const moneyFormat = data && data.moneyFormat;
  const totalFulfill = (
    <Card.Section>
      <InlineStack>
        <Text as="span" fontWeight="semibold">
          {cms("label.total")}
        </Text>
        <Text variant="bodySm" as="p">
          (
          {countItems > 1
            ? `${countItems}
                ${cms("label.items")} from ${addVendorTxt}`
            : `${countItems}
                ${cms("label.item")} from ${addVendorTxt}`}
          )
        </Text>
        <Text as="span" fontWeight="semibold">
          {`${moneyFormat || constant.symbol.DOLLAR} ${totalAmount.toFixed(2)}`}
        </Text>
      </InlineStack>
    </Card.Section>
  );
  return [lineItems, totalFulfill];
};

export default FulfilledLineItems;
